import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import WhatIf from './WhatIf';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GearTracker from './GearTracker.js';
import GearTrackerCreate from './GearTrackerCreate.js';
import StaticNotFound from './StaticNotFound.js';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<GearTrackerCreate />} />
      <Route path="/whatif/" element={<WhatIf />} />
      <Route path="/gearing/" element={<GearTrackerCreate />} />
      <Route path="/gearing/:id" element={<GearTracker />} />
      <Route path="/StaticNotFound" element={<StaticNotFound />} />
    </Routes>

    <div style={{ textAlign: "center", position: "relative", bottom: 0, marginTop: '50px' }}>
      Powered by Criminal Space
    </div>
    <div style={{ textAlign: "center", position: "relative", bottom: 0, marginTop: '25px', marginBottom: '50px' }}>
      <img src="https://beta.legiontd2.com/images/web/discord-icon.png" style={{ width: 20, marginRight: '5px' }}></img> bruhshit (yes that's my username)
    </div>
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '-20px' }}>
      <div><a target="Support me!" href="https://ko-fi.com/yeetoid"><img src={require('./Media/kofi.png')} style={{ width: '175px' }} /></a></div>
    </div>
  </BrowserRouter>

);

